import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6961f5ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-item" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-bottom":"0.4rem"} }, "Select a payment date and an amount:", -1))
const _hoisted_4 = {
  title: "Select a date for confirmed ledger tranfers",
  class: "search-with-button"
}
const _hoisted_5 = {
  class: "date-picker",
  style: {"width":"50%"}
}
const _hoisted_6 = ["disabled"]

import { ref, computed } from "vue";
import DatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import Popup from "@/components/Popup.vue";
import CurrencyInput from "@/components/CurrencyInput.vue";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import useSpinnerPopup from "@/services/composables/SpinnerPopup";
import { authService } from "@/auth/authSingleton";
import {
    CurrencySymbol,
    MarketCurrency,
    MonetaryValueWithCommas,
} from "@/services/helpers/Helper";
import { VatLoan } from "@/models/VatLoan";
import { DrawdownHelper } from "@/services/helpers/DrawdownHelper";
import IConfirmLoanPaymentRequest from "@/Interfaces/Ledgering/IConfirmLoanPaymentRequest";

//Services

export default /*#__PURE__*/_defineComponent({
  __name: 'LoanPaymentPopUp',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit: __emit }) {

const DrawdownServices: DrawdownHelper = new DrawdownHelper();
const urlParams = process.env.VUE_APP_VAT_LOAN_PAYMENT_URL_PARAMS!;

const props = __props;
const selectedRow = computed({
    get() {
        return props.modelValue;
    },
    set(val) {
        emits("update:modelValue", val);
    },
});
const working = ref(false);
const selectedDate = ref<Date>();
const textInputOptions = { format: "yyyy/MM/dd" };
const paymentAmount = ref("");

const emits = __emit;
function closeChild() {
    selectedDate.value = undefined;
    paymentAmount.value = "";
    selectedRow.value = undefined;
}
const FormatDatePicker = (date: Date) => {
    return date.toLocaleString("sv-SE").split(" ")[0].replaceAll("-", "/");
};
async function ConfirmLoanPayment() {
    if (working.value) return;
    working.value = true;
    const closeSpinner = useSpinnerPopup().show();
    try {
        if (!selectedRow.value) throw new ReferenceError("selectedRow cannot be null when submitting the form");
        const payload: IConfirmLoanPaymentRequest = {
            Market: selectedRow.value.Market!,
            DrawdownDate: selectedRow.value.DrawdownDate!.toLocaleString('sv-SE').split(" ")[0],
            VatLoanAmount: selectedRow.value.RemainingBalance!,
            VatLoanPeriod: selectedRow.value.VatLoanPeriod.toLocaleString('sv-SE').split(" ")[0],
            PaymentDate: selectedDate.value!.toLocaleString('sv-SE').split(" ")[0],
            PaymentAmount: `${paymentAmount.value}`,
            UserEmail: authService.getEmailAddress(),
        };
        await DrawdownServices.confirmPayment(urlParams, payload);
        useNotifierWithErrFormatter().success({
            msg: "Payment successfully registered.",
        });
        closeChild();
        emits("confirm");
    } catch (error) {
        useNotifierWithErrFormatter().error({
            name: `${__filename}/${ConfirmLoanPayment.name}`,
            errorType: "Confirming Loan payment",
            error,
        });
    } finally {
        closeSpinner();
        working.value = false;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    modelValue: !!selectedRow.value,
    "onUpdate:modelValue": closeChild,
    title: "Loan Re-Payment Confirmation",
    hasClose: ""
  }, _createSlots({ _: 2 }, [
    (selectedRow.value)
      ? {
          name: "contents",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createTextVNode(" The remaining balance on this VAT Loan is: "),
              _createElementVNode("strong", null, _toDisplayString(_unref(CurrencySymbol)[_unref(MarketCurrency)[selectedRow.value.Market!]]) + _toDisplayString(_unref(MonetaryValueWithCommas)(selectedRow.value.RemainingBalance)), 1)
            ]),
            _createElementVNode("form", {
              class: "top-content",
              onSubmit: _withModifiers(ConfirmLoanPayment, ["prevent"])
            }, [
              _hoisted_3,
              _createElementVNode("span", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(DatePicker), {
                    modelValue: selectedDate.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDate).value = $event)),
                    type: "date",
                    "enable-time-picker": false,
                    format: FormatDatePicker,
                    placeholder: "Select Date...",
                    "text-input-options": textInputOptions,
                    "text-input": "",
                    "max-date": new Date(),
                    teleport: true,
                    required: ""
                  }, null, 8, ["modelValue", "max-date"])
                ]),
                _createVNode(CurrencyInput, {
                  modelValue: paymentAmount.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((paymentAmount).value = $event)),
                  min: 0.01,
                  max: selectedRow.value.RemainingBalance,
                  currency: _unref(MarketCurrency)[selectedRow.value.Market!],
                  style: {"border-radius":"0"},
                  required: ""
                }, null, 8, ["modelValue", "max", "currency"]),
                _createElementVNode("button", {
                  disabled: working.value,
                  class: "right-button"
                }, "Confirm", 8, _hoisted_6)
              ])
            ], 40, _hoisted_2)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["modelValue"]))
}
}

})